
import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import { SweetModal } from 'sweet-modal-vue';
import {RSSFeed} from "@/stores/RSS";
import stores from '@/stores';
import {Message} from "@/stores/Messaging";
import NevronInput from "@/components/NevronInput.vue";
import NevronImageField from "@/components/NevronImageField.vue";
import {showToaster} from "@/components/DashboardComposer/helpers";


@Component({
  components: {
    NevronImageField,
    NevronInput,
    SweetModal,
  },
})

export default class CreateRSSFeed extends Vue {

  @Prop({default: false})
  emitCreated!: boolean;

  renderKey = 0;


  newFeed: RSSFeed = new RSSFeed({});

  @Prop({default: null})
  item!: IRSSFeed | null;

  get isEditMode() {
    return !!this.item;
  }

  @Watch('item', {immediate: true})
  onItemChanged() {
    if (this.isEditMode) {
      this.newFeed = new RSSFeed(this.item!);
    }
  }
  imageSelected(image: IMediaItem) {
    if (this.newFeed) {
      this.newFeed.imageId = (image) ? image.id : null;
    }
  }
  onSubmit() {
    if (this.validateForm('create-form')) {
      const promise = this.isEditMode ? stores.RSS.updateItem(this.newFeed): stores.RSS.createNewItem(this.newFeed);
      promise.then(() => {
        const toEmit = this.isEditMode ? 'save' : 'created';
        showToaster('success', '', `RSS feed has been ${toEmit === 'save'? 'updated' : 'created'} successfully`)
        this.$emit(toEmit)
        this.cancel();
      });
    }
  }

  validateForm(formRef: string): boolean {
    const form = this.$refs[formRef] as HTMLFormElement;
    form.classList.add('was-validated');
    return form.checkValidity();
  }

  cancel() {
    // @ts-ignore
    this.$refs.create.close();
    this.newFeed = new RSSFeed({});
    this.renderKey++;
  }
}

